<template>
  <div class="tce-grid-sort">
    <div class="tce-grid-sort__wrapper">
      <button
        ref="dropdownTrigger"
        class="tce-grid-sort__dropdown-trigger"
        :aria-expanded="isDropdownShown"
        @click="toggleDropdown"
      >
        {{ sortByDictionary }}
      </button>
      <ul v-show="isDropdownShown" class="tce-grid-sort__content">
        <li v-for="(item, index) in sortList" :key="index">
          <button
            :class="[
              'tce-grid-sort__content-item',
              { 'tce-grid-sort__content-item--active': item.active },
            ]"
            :aria-current="item.active"
            @click="selectSort(item, index)"
          >
            {{ item.name }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tce-grid-sort',
};
</script>

<script setup>
import { ref } from 'vue';
import { AnalyticsHandler } from '../../directives/analyticsHandler';

const props = defineProps({
  sort: {
    type: Array,
    default: () => [],
  },
  sortByDictionary: { type: String, default: 'Sort by' },
  analytics: {
    type: Object,
    default: () => {},
  },
});

const emit = defineEmits(['sort-updated']);

const sortList = ref(props.sort);
const isDropdownShown = ref(false);
const dropdownTrigger = ref(null);

function toggleDropdown(event) {
  if (!event || event.pointerType !== 'mouse') {
    setTimeout(() => {
      dropdownTrigger.value.focus();
    }, 250);
  }

  isDropdownShown.value = !isDropdownShown.value;
}

function selectSort(sortItem, index) {
  if (sortItem.active) {
    toggleDropdown();
    return;
  }

  sortList.value.forEach((sortListItem, tmpIndex) => {
    sortListItem.active = tmpIndex === index;
  });

  pushAnalytics(sortItem);

  emit('sort-updated', sortItem);
  toggleDropdown();
}

function pushAnalytics(sortItem) {
  const tag = {
    type: 'userActionEvent',
    ...props.analytics,
    label: sortItem.name,
    filter_value: sortItem.name,
  };

  try {
    AnalyticsHandler.getAnalyticsHandler().push(tag);
  } catch (e) {
    /* istanbul ignore next */
    console.warn('Could not push to dataLayer', tag);
  }
}
</script>
